// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sent-buttons .left[data-v-688a719f]{position:absolute;left:15px}@media (max-width:575px){.sent-buttons[data-v-688a719f]{width:100%}.sent-buttons .left[data-v-688a719f]{position:relative;left:0;display:block;width:100%}.sent-buttons .btn-xs-block[data-v-688a719f]{width:100%}}", ""]);
// Exports
module.exports = exports;
